import { appConfig as $config } from '../../app.config';
import { UI } from '../../modules/UI';
import { User } from '../../modules/User';
//import { taskManagment, alertManagment } from '../../modules/ReactComponent';

import './scss/aside.scss';

export const Main = (function () {
  let wrapper = (data = {}) => {
    data.isAdminFantec = User.isAdminFantec();

    return new Promise((resolve, reject) => {
      let template = require(`./tmpl/main.hbs`);
      UI.pagewrap(template, data).then(() => {
        mainHeaderInit();

        // Account switch Listener
        window.addEventListener('accountreload:complete', mainHeaderInit);

        resolve();
      });
    });
  };

  const mainHeaderInit = () => {
    if ($config.APP_REACT) {
      return;
    }

    // taskManagment.init('taskManagementBtn');

    //alertManagment.wrapper('alertManagementBtn', 'alerts-modal-container');

    $('#userSignoutBtn').off().on('click', User.signout);
  };

  return {
    wrapper
  };
})();
